import { usePost } from '../useFetch';
import { ContactMessage } from '@scope/scope-one-common/types/contact';

export const useContactSales = () =>
  usePost<ContactMessage>(({ message, subject }) => ({
    url: `/shop/contact-sales/`,
    options: {
      response: 'text',
      payload: {
        message,
        origin: window.location.href,
        subject,
      },
    },
  }));
